// src/App.js - MainLayout ile güncellendi

import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';

// --- YENİ MUI Importları ---
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import theme from './theme'; // Yeni tema dosyamız
// --- Bitiş ---

// <-- YENİ: Layout'u import et -->
import MainLayout from './components/MainLayout';
import { ErrorBoundary } from './components/ErrorBoundary';
import AdminRoute from './components/AdminRoute';
import './App.css'; // İçi boş

// --- Sayfa Importları ---
// Giriş sayfası ilk açılan ekran olduğu için statik kalıyor (bölmek gereksiz gecikme yaratır).
import LoginPage from './pages/LoginPage';

// Diğer tüm sayfalar route bazlı bölünüyor: her sayfa ancak o rotaya girilince indiriliyor.
// Böylece ağır kütüphaneler (jspdf, xlsx, recharts, DataGrid) ana bundle'da taşınmıyor.
const SignUpPage = lazy(() => import('./pages/SignUpPage'));
const HomePage = lazy(() => import('./pages/HomePage'));
const CoursePage = lazy(() => import('./pages/CoursePage'));
const QuizPage = lazy(() => import('./pages/QuizPage'));
const MyCoursesPage = lazy(() => import('./pages/MyCoursesPage'));
const CertificateVerificationPage = lazy(() => import('./pages/CertificateVerificationPage'));
const QrVerificationPage = lazy(() => import('./pages/QrVerificationPage'));

const AdminDashboard = lazy(() => import('./pages/admin/AdminDashboard'));
const AddCoursePage = lazy(() => import('./pages/admin/AddCoursePage'));
const AssignCoursePage = lazy(() => import('./pages/admin/AssignCoursePage'));
const CoursesReportPage = lazy(() => import('./pages/admin/CoursesReportPage'));
const CourseDetailReportPage = lazy(() => import('./pages/admin/CourseDetailReportPage'));
const DepartmentsReportPage = lazy(() => import('./pages/admin/DepartmentsReportPage'));
const PersonReportPage = lazy(() => import('./pages/admin/PersonReportPage'));
const TestCoursesListPage = lazy(() => import('./pages/admin/TestCoursesListPage'));
const TestCoursePage = lazy(() => import('./pages/admin/TestCoursePage'));
const TestQuizPage = lazy(() => import('./pages/admin/TestQuizPage'));
const EditCoursesListPage = lazy(() => import('./pages/admin/EditCoursesListPage'));
const EditCoursePage = lazy(() => import('./pages/admin/EditCoursePage'));
const AddUserPage = lazy(() => import('./pages/admin/AddUserPage'));
const AddExternalRecordPage = lazy(() => import('./pages/admin/AddExternalRecordPage'));
const DefineMandatoryCoursesPage = lazy(() => import('./pages/admin/DefineMandatoryCoursesPage'));
const EducationFollowUpListPage = lazy(() => import('./pages/admin/EducationFollowUpListPage'));
const ManageUsersPage = lazy(() => import('./pages/admin/ManageUsersPage'));
const ManageDepartmentsPage = lazy(() => import('./pages/admin/ManageDepartmentsPage'));
const CertificateApprovalsPage = lazy(() => import('./pages/admin/CertificateApprovalsPage'));
const TrainingMatrixPage = lazy(() => import('./pages/admin/TrainingMatrixPage'));
const DevToolsPage = lazy(() => import('./pages/admin/DevToolsPage'));
const AssignmentsPage = lazy(() => import('./pages/admin/AssignmentsPage'));
// --- Importlar Bitiş ---

function ProtectedRoute({ children }) {
        const { currentUser } = useAuth();
        return currentUser ? children : <Navigate to="/" />;
}

// Sayfa parçası indirilirken gösterilir
function PageLoader() {
        return (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
                        <CircularProgress />
                </Box>
        );
}

function App() {
        return (
                // --- YENİ: Tema Sağlayıcı ---
                <ThemeProvider theme={theme}>
                        <CssBaseline />
                        {/* CssBaseline, tarayıcı stillerini sıfırlar ve karanlık modu uygular */}
                        <AuthProvider>
                                <ErrorBoundary>
                                <Router>
                                        {/* Eski .App ve .App-header div'leri kaldırıldı */}
                                        <Suspense fallback={<PageLoader />}>
                                        <Routes>
                                                {/* Layout KULLANILMAYAN Rotalar */}
                                                <Route path="/" element={<LoginPage />} />
                                                <Route path="/signup" element={<SignUpPage />} />
                                                <Route path="/verify-certificate" element={<CertificateVerificationPage />} />
                                                <Route path="/verify-qr" element={<QrVerificationPage />} />

                                                {/* Layout KULLANILAN Kullanıcı Rotaları */}
                                                <Route path="/home" element={<ProtectedRoute><MainLayout><HomePage /></MainLayout></ProtectedRoute>} />
                                                <Route path="/course/:courseId" element={<ProtectedRoute><MainLayout><CoursePage /></MainLayout></ProtectedRoute>} />
                                                <Route path="/quiz/:courseId" element={<ProtectedRoute><MainLayout><QuizPage /></MainLayout></ProtectedRoute>} />
                                                <Route path="/my-courses" element={<ProtectedRoute><MainLayout><MyCoursesPage /></MainLayout></ProtectedRoute>} />

                                                {/* Layout KULLANILAN Admin Rotaları */}
                                                <Route path="/admin" element={<AdminRoute><MainLayout><AdminDashboard /></MainLayout></AdminRoute>} />
                                                <Route path="/admin/add-course" element={<AdminRoute><MainLayout><AddCoursePage /></MainLayout></AdminRoute>} />
                                                <Route path="/admin/assign-course" element={<AdminRoute><MainLayout><AssignCoursePage /></MainLayout></AdminRoute>} />
                                                <Route path="/admin/test-course" element={<AdminRoute><MainLayout><TestCoursesListPage /></MainLayout></AdminRoute>} />
                                                <Route path="/admin/test-course/:courseId" element={<AdminRoute><MainLayout><TestCoursePage /></MainLayout></AdminRoute>} />
                                                <Route path="/admin/test-quiz/:courseId" element={<AdminRoute><MainLayout><TestQuizPage /></MainLayout></AdminRoute>} />
                                                <Route path="/admin/edit-course" element={<AdminRoute><MainLayout><EditCoursesListPage /></MainLayout></AdminRoute>} />
                                                <Route path="/admin/edit-course/:courseId" element={<AdminRoute><MainLayout><EditCoursePage /></MainLayout></AdminRoute>} />
                                                <Route path="/admin/add-user" element={<AdminRoute><MainLayout><AddUserPage /></MainLayout></AdminRoute>} />
                                                <Route path="/admin/add-external-record" element={<AdminRoute><MainLayout><AddExternalRecordPage /></MainLayout></AdminRoute>} />
                                                <Route path="/admin/define-mandatory-courses" element={<AdminRoute><MainLayout><DefineMandatoryCoursesPage /></MainLayout></AdminRoute>} />
                                                <Route path="/admin/reports/by-course" element={<AdminRoute><MainLayout><CoursesReportPage /></MainLayout></AdminRoute>} />
                                                <Route path="/admin/reports/by-course/:courseId" element={<AdminRoute><MainLayout><CourseDetailReportPage /></MainLayout></AdminRoute>} />
                                                <Route path="/admin/reports/by-person" element={<AdminRoute><MainLayout><DepartmentsReportPage /></MainLayout></AdminRoute>} />
                                                <Route path="/admin/reports/by-person/:department" element={<AdminRoute><MainLayout><PersonReportPage /></MainLayout></AdminRoute>} />
                                                <Route path="/admin/reports/by-person/:department/:userId" element={<AdminRoute><MainLayout><PersonReportPage /></MainLayout></AdminRoute>} />
                                                <Route path="/admin/education-followup" element={<AdminRoute><MainLayout><EducationFollowUpListPage /></MainLayout></AdminRoute>} />
                                                <Route path="/admin/manage-users" element={<AdminRoute><MainLayout><ManageUsersPage /></MainLayout></AdminRoute>} />
                                                <Route path="/admin/manage-departments" element={<AdminRoute><MainLayout><ManageDepartmentsPage /></MainLayout></AdminRoute>} />
                                                <Route path="/admin/approvals" element={<AdminRoute><MainLayout><CertificateApprovalsPage /></MainLayout></AdminRoute>} />
                                                <Route path="/admin/training-matrix" element={<AdminRoute><MainLayout><TrainingMatrixPage /></MainLayout></AdminRoute>} />
                                                <Route path="/admin/dev-tools" element={<AdminRoute><MainLayout><DevToolsPage /></MainLayout></AdminRoute>} />
                                                <Route path="/admin/assignments" element={<AdminRoute><MainLayout><AssignmentsPage /></MainLayout></AdminRoute>} />
                                        </Routes>
                                        </Suspense>
                                </Router>
                                </ErrorBoundary>
                        </AuthProvider>
                </ThemeProvider>
                // --- Tema Sağlayıcı Bitişi ---
        );
}

export default App;